/* eslint react/prop-types: 0 */
import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { isAuthenticated } from '../redux/auth';

const mapLoggedInProps = ({ auth, router }) => ({
    loggedIn: isAuthenticated(auth),
    path: encodeURIComponent(router.location.pathname + router.location.search),
});

const loginRequired = (BaseComponent) => {
    const factory = React.createFactory(BaseComponent);
    const LoginCheck = ({ loggedIn, path, ...props }) => {
        if (loggedIn) {
            return factory(props);
        }
        let to = '/login';
        if (path !== '/') {
            to = `${to}?next=${path}`;
        }
        return (<Redirect to={to} />);
    };
    return connect(mapLoggedInProps)(LoginCheck);
};

export default loginRequired;



// WEBPACK FOOTER //
// ./src/client/hoc/loginRequired.js